import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const RemoveIcon = createSvgIcon(
  <>
    <title></title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      transform="translate(0.5 0.5)"
    >
      <line
        fill="none"
        stroke="#222222"
        strokeMiterlimit="10"
        x1="27"
        x2="5"
        y1="5"
        y2="27"
      />{' '}
      <line
        fill="none"
        stroke="#222222"
        strokeMiterlimit="10"
        x1="27"
        x2="5"
        y1="27"
        y2="5"
      />
    </g>
  </>
)
